import React, { ImgHTMLAttributes } from 'react'

type Iprops = ImgHTMLAttributes<HTMLImageElement> & {
  width: number | string;
  height: number | string;
}

const Image: React.FC<Iprops> = (props) => {
  const { ...rest } = props;
  return (
    <img {...rest} alt="" />
  )
}

export default Image;
